import UserConsignementInfo from './UserConsignementInfo'
export default UserConsignementInfo
